export default class S3DocumentMetaDataWithUrl {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.bucketName = jsonResponse["bucket-name"];
        this.filepath = jsonResponse["filepath"];
        this.documentType = jsonResponse["document-type"];
        this.presignedUrl = jsonResponse["presigned-url"];

    }

    static toJson = function (item) {
        let jsonObj = {};
        jsonObj["id"] = item.id;
        jsonObj["bucket-name"] = item.bucketName;
        jsonObj["filepath"] = item.filepath;
        jsonObj["document-type"] = item.documentType;
        jsonObj["presigned-url"] = item.presignedUrl;
        return jsonObj;
    };
}